// setShouldDisplayHorizonLayoutHint.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set should display horizon layout hint
 * @kind action
 * @return {Promise} Action promise.
 */
const setShouldDisplayHorizonLayoutHint =
  ({ shouldDisplayHorizonLayoutHint }) =>
  async dispatch => {
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['liveStream'],
        data: {
          shouldDisplayHorizonLayoutHint,
        },
      },
    });
  };

export default setShouldDisplayHorizonLayoutHint;
